export const weekDays = [
  { value: '1', label: '一' },
  { value: '2', label: '二' },
  { value: '3', label: '三' },
  { value: '4', label: '四' },
  { value: '5', label: '五' },
  { value: '6', label: '六' },
  { value: '0', label: '日' },
];

export const monthDays = Array.from({ length: 31 }, (_, i) => ({
  value: `${i + 1}`,
  label: `${i + 1}日`,
}));

export const hours = Array.from({ length: 24 }, (_, i) => ({
  value: `${i}`,
  label: `${i} 點`,
}));
